module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "ingress"
  }, [_vm._v("BOKA VÅRA FÖRMÅNLIGA PERIODLIFTKORT")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', [_vm._v("HELGKORT")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', [_vm._v("KORTVECKA")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', [_vm._v("VECKA")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("Under jul och nyår ger vi helg- och kortveckopriser på våra 4- och 5-dagarskort (när kortet följer boendeperioden), priset är justerat i onlinebokningen.")]), _vm._v(" "), _c('Collapsable', {
    attrs: {
      "title": "Så fungerar det med liftkort",
      "content": "\n    <p>I Branäs använder vi ett så kallat keycard på vilket du kan ladda ditt liftkort. Du använder sedan detta kort för att komma in till liftarna. Du laddar kortet med den tid du vill åka skidor, från tre timmar och uppåt.</p>\n    <p>Alla barn under åtta år åker gratis. De behöver dock ett keycard för att kunna åka och det kostar 55kr. När du har köpt ett keycard så kan du spara det till nästa säsong och det fungerar dessutom i våra övriga anläggningar som exempelvis Kungsberget och Vallåsen.</p>\n    <div class='clickable button-box'>\n        <a href='/boka/boka-online/#search/1001'>Köp liftkort   </a><i class='fa fa-arrow-right'></i>\n    </div>\n    <p>\n    </p>\n    "
    }
  }), _vm._v(" "), _c('Collapsable', {
    attrs: {
      "title": "Här köper du liftkort",
      "content": "\n    <p>Du kan köpa ditt liftkort redan nu på webben. Då kan du köpa ett helt nytt liftkort eller ladda på ett befintligt keycard, se ”Så fungerar det med liftkort” här ovanför, för att läsa mer om liftkort och keycard.</p>\n    <div class='clickable button-box'>\n        <a href='/boka/boka-online/#search/1001'>Köp liftkort   </a><i class='fa fa-arrow-right'></i>\n    </div>\n    <p> </p>\n    <p>Du kan också köpa liftkortet på plats i Branäs, i våra infocenter, skidhyrorna, sportshopen och i våra närlivsbutiker. På pistkartan hittar du inköpsställen för våra liftkort.</p>\n    <div class='clickable button-box small-button'>\n        <a href='/skidakning/backar-och-liftar/#pistkartor'>Till våra pistkartor   </a><i class='fa fa-arrow-right'></i>\n    </div>\n    <p>\n    </p>\n    "
    }
  }), _vm._v(" "), _c('Collapsable', {
    attrs: {
      "title": "Tips - Undvik köer, köp dina liftkort på webben!",
      "content": "\n    <p>Om du köper dina liftkort redan nu på webben så levereras de direkt i ert incheckningskuvert när ni kommer fram. På så sätt slipper ni börja semestern med att köa och kan snabbt ge er ut i backarna.</p>\n    <div class='clickable button-box'>\n        <a href='/boka/boka-online/#search/1001'>Köp liftkort   </a><i class='fa fa-arrow-right'></i>\n    </div>\n    <p>\n    </p>\n    "
    }
  }), _vm._v(" "), _vm._m(4)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Köper du våra periodkort får du alltid förmånliga priser."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("(Gäller tor-sön)"), _c('br')]), _vm._v("Vuxen: 1240:-"), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('br')]), _vm._v("Ungdom: 960:-")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("(Gäller sön-tor)"), _c('br')]), _vm._v("Vuxen: 1520:-"), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('br')]), _vm._v("Ungdom: 1225:-")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("(Gäller sön-sön eller tor-tor)"), _c('br')]), _vm._v("Vuxen: 1830:-"), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('br')]), _vm._v("Ungdom: 1420:-")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "following-info"
  }, [_c('h2', {
    attrs: {
      "id": "ladda-liftkort"
    }
  }, [_vm._v("Ladda liftkort")]), _vm._v(" "), _c('p', [_vm._v("Har ni redan befintliga keycard hemma? Ladda korten enkelt via ”Ladda liftkort” nedan. Liftkortet kan användas när som helst under säsongen och aktiveras när du använder det första gången.")]), _vm._v(" "), _c('p', [_vm._v("”Ladda liftkort” öppnar under hösten 2017, önskar ni ladda era keycard redan nu ring oss på 054-13 26 00 eller klicka er in på vår "), _c('a', {
    attrs: {
      "href": "/boka/boka-online/#search/1001"
    }
  }, [_vm._v("onlinebokning")]), _vm._v(".")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("1. "), _c('strong', [_vm._v("Ladda")]), _vm._v(" ditt keycard med önskat antal åkdagar.")]), _vm._v(" "), _c('p', [_vm._v("2. "), _c('strong', [_vm._v("Betala")]), _vm._v(" med kort eller via Swish.")]), _vm._v(" "), _c('p', [_vm._v("3. Nu är det bara att åka!")]), _vm._v(" "), _c('div', {
    staticClass: "clickable button-box center"
  }, [_c('a', {
    attrs: {
      "href": "https://hyra.branas.se/liftkort",
      "target": "_blank"
    }
  }, [_vm._v("Ladda liftkort   ")]), _c('i', {
    staticClass: "fa fa-arrow-right"
  })]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "gratis-for-barn"
    }
  }, [_vm._v("Gratis för barn")]), _vm._v(" "), _c('p', [_vm._v("I Branäs är alla aktiviteter gratis för barn med liftkort. Är barnen under åtta år bjuder vi dessutom på liftkortet. Men glöm inte att barnen behöver ett eget keycard som kostar 55kr, läs mer om liftkort och keycard under boxen ”"), _c('span', {
    staticStyle: {
      "font-weight": "400"
    }
  }, [_vm._v("Så fungerar det med liftkort”")]), _c('span', {
    staticStyle: {
      "font-weight": "400"
    }
  }, [_vm._v(" här ovanför.")]), _vm._v(" "), _c('br'), _c('strong', [_c('span', {
    staticStyle: {
      "font-weight": "400"
    }
  }, [_vm._v("För lite extra energipåfyllning ute i backen bjuder vi alla barn på varm ekologisk saft.")])])]), _vm._v(" "), _c('p', [_vm._v("Se mer om alla "), _c('a', {
    attrs: {
      "title": "För barn",
      "href": "/barn-bjornbusen-branas/"
    }
  }, [_vm._v("roliga aktiviteter som är gratis för barn")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "dela-liftkort"
    }
  }, [_vm._v("Dela liftkort med föräldrakortet")]), _vm._v(" "), _c('p', [_vm._v("Föräldrakortet är perfekt för föräldrar som reser till Branäs med små barn. Köp ett kort gemensamt och dela med din partner, en av er kan vara med barnen och en kan åka skidor.")]), _vm._v(" "), _c('div', {
    staticClass: "clickable button-box center"
  }, [_c('a', {
    attrs: {
      "href": "/boka/boka-online/#search/1001"
    }
  }, [_vm._v("Köp liftkort online   ")]), _c('i', {
    staticClass: "fa fa-arrow-right"
  })]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "priser-for-liftkort"
    }
  }, [_vm._v("Priser och varianter")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "has-image"
  }, [_c('img', {
    staticClass: "alignnone size-medium wp-image-6860",
    attrs: {
      "src": "https://www.branas.se/wp-content/uploads/2016/12/skidskola-470x385.jpg",
      "alt": "skidskola",
      "width": "470",
      "height": "385"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("liftkort 2017-18")]), _vm._v(" "), _c('table', {
    staticClass: "responsive price-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "number"
  }, [_vm._v("Vuxen")]), _vm._v(" "), _c('th', {
    staticClass: "number"
  }, [_vm._v("Ungdom")]), _vm._v(" "), _c('th', {
    staticClass: "number"
  }, [_vm._v("Föräldrakort")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("3 timmar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 360")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 285")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 dag")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 405")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 315")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 570")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 795")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 625")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1110")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1140")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 905")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1600")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Långhelg (to–sö)")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v("1240")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 960")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1740")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1455")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1140")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2040")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kortvecka (sö–to)")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1520")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1225")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2130")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1725")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1375")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2420")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Vecka (6–8 dagar)")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1830")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1420")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2560")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("9 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1950")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1525")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2730")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("10 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2120")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1610")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2970")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("11 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2340")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1690")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2970")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("12 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2470")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1770")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 3460")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("13 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2640")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1860")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 3700")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("14 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2760")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1950")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 3860")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Säsongskort")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 4595")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 3495")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  })])])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('h3', [_vm._v("Priskategorier")]), _vm._v(" "), _c('p', [_vm._v("Vuxen: 18 år-\n          "), _c('br'), _vm._v(" Ungdom: 7-17 år\n          "), _c('br'), _vm._v(" Barn: 0-6 år")]), _vm._v(" "), _c('p', [_vm._v("Keycard krävs för att kunna ladda på ett liftkort, det kostar 55 kr. Spara ditt Keycard till nästa säsong och ladda det på nytt.")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "clickable button-box center"
  }, [_c('a', {
    attrs: {
      "href": "/boka/boka-online/#search/1001"
    }
  }, [_vm._v("Köp liftkort online   ")]), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ea1162c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/Skipass/Page.vue
// module id = 1006
// module chunks = 0